var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBabySeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37866 25.694L4.75366 3.33984C4.75366 3.33984 12.8474 4.88151 12.8474 7.96484C12.8474 9.89193 9.76408 11.0482 10.9203 12.2044C12.0766 13.3607 16.3162 14.5169 16.3162 17.6003C16.3162 19.5273 15.052 20.9611 16.3162 22.2253C17.4724 23.3815 18.6287 22.7756 20.5557 22.2253C22.7141 21.6086 27.1078 21.069 28.6495 21.4544C30.1912 21.8398 31.7328 22.6107 31.7328 24.9232C31.7328 26.1951 30.962 27.6211 29.0349 28.0065C27.1078 28.3919 24.7953 26.4648 21.712 26.4648C18.6287 26.4648 14.7745 28.7773 12.462 28.7773C10.1495 28.7773 9.37866 25.694 9.37866 25.694Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6495 28.0059L30.962 34.1725H5.5245L10.1495 28.0059",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabySeat);
export default __webpack_public_path__ + "static/media/baby_seat.643c634b912056115bf22da7bd612871.svg";
export { ForwardRef as ReactComponent };